module.exports = __webpack_public_path__ + "static/media/jess.findlay_-IG-1.49bdf986.PNG";